var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedux(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.881 42.106c2.177-.225 3.829-2.102 3.754-4.355a4.22 4.22 0 0 0-4.204-4.054h-.15c-2.328.075-4.13 2.027-4.054 4.355.075 1.126.525 2.102 1.201 2.778-2.553 5.031-6.457 8.71-12.313 11.788-3.979 2.102-8.109 2.853-12.238 2.328-3.379-.451-6.006-1.952-7.658-4.43-2.402-3.679-2.628-7.658-.6-11.638 1.427-2.853 3.679-4.956 5.105-6.007-.3-.976-.751-2.628-.976-3.829C-.14 36.925.986 47.587 4.29 52.618c2.478 3.754 7.508 6.082 13.064 6.082 1.502 0 3.003-.15 4.505-.525 9.61-1.877 16.893-7.584 21.022-16.068zm13.214-9.31C50.389 26.113 41.98 22.434 32.37 22.434h-1.201c-.676-1.351-2.102-2.253-3.679-2.253h-.15c-2.327.075-4.129 2.027-4.054 4.355a4.22 4.22 0 0 0 4.204 4.054h.15a4.23 4.23 0 0 0 3.679-2.553h1.351c5.706 0 11.112 1.652 15.992 4.88 3.754 2.478 6.457 5.706 7.958 9.611 1.276 3.154 1.201 6.232-.15 8.86-2.102 3.979-5.631 6.157-10.286 6.157-3.003 0-5.856-.901-7.358-1.577-.826.751-2.328 1.952-3.379 2.703C38.676 58.174 41.98 59 45.133 59c7.208 0 12.538-3.98 14.566-7.959 2.177-4.355 2.027-11.863-3.604-18.245zM17.954 43.382a4.22 4.22 0 0 0 4.204 4.054h.15c2.328-.075 4.129-2.027 4.054-4.355a4.22 4.22 0 0 0-4.204-4.054h-.15c-.15 0-.376 0-.525.075-3.078-5.106-4.355-10.661-3.904-16.668.3-4.505 1.802-8.409 4.43-11.638 2.177-2.778 6.382-4.13 9.235-4.204 7.958-.15 11.337 9.761 11.562 13.74.976.225 2.628.751 3.754 1.126-.901-12.163-8.409-18.47-15.617-18.47-6.757 0-12.989 4.88-15.467 12.088-3.454 9.611-1.201 18.846 3.003 26.129-.375.525-.601 1.351-.525 2.177z",
    fill: "#764abc",
    fillRule: "nonzero",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedux);
export default __webpack_public_path__ + "static/media/redux.9af82c70955324ca7553d7de3d8cc8a1.svg";
export { ForwardRef as ReactComponent };